/* Versand-Aktion – 7 O'CLOCK (angelegt 04.10.2026)
   Gemeinsame Logik für den Aktionskasten auf der Produktseite (assets/custom-product-buybox.js)
   und im Warenkorb-Drawer (hier unten, mountCart). Daten: snippets/7oc-versand-aktion.liquid
   gibt die aktiven Einträge aus Admin > Inhalte > Metaobjekte > Versand-Aktion als window.ocPromos aus.
   Styles: assets/custom-promo.css. Eingebunden global über snippets/gtm-head.liquid.

   window.ocPromo = {
     active(price)   → passende Aktion (Zeitfenster, Land, Mindestpreis, Priorität) oder null
     render(promo)   → fertiges Kasten-Element (Icon | Titel + Unterzeile | Uhr)
     format(ms)      → „HH:MM:SS"
     geoCountry()    → Land der Besucherin (IP, Standard „DE")
     onChange(fn)    → fn wird gerufen, wenn eine Aktion startet/endet oder das Land bekannt wird
   }
   Ein Ticker aktualisiert sekündlich alle Uhren (.oc-ship-timer) auf der Seite. */
(function () {
  'use strict';
  var BG = '#32a852', FG = '#ffffff';

  function toNumber(text) {
    var m = (text || '').match(/\d[\d.]*(?:,\d+)?/);
    if (!m) return NaN;
    return parseFloat(m[0].replace(/\./g, '').replace(',', '.'));
  }

  /* Land per Shopify-Geo-Endpunkt (IP-basiert). Bis die Antwort da ist, gilt „DE". */
  var geo = null;
  function geoCountry() {
    if (geo) return geo;
    try { geo = sessionStorage.getItem('oc-geo-country'); } catch (e) {}
    return geo || 'DE';
  }
  function loadGeo() {
    try { if (sessionStorage.getItem('oc-geo-country')) return; } catch (e) {}
    if (typeof fetch !== 'function') return;
    fetch('/browsing_context_suggestions.json?country[enabled]=true', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!c) return;
        geo = String(c).toUpperCase();
        try { sessionStorage.setItem('oc-geo-country', geo); } catch (e) {}
        notify();
      })
      .catch(function () {});
  }

  function list() { return window.ocPromos || []; }
  function inWindow(p, now) { return p && p.ende && p.ende > now && !(p.start && p.start > now); }
  function active(price) {
    var now = Date.now() / 1000, best = null, l = list();
    for (var i = 0; i < l.length; i++) {
      var p = l[i];
      if (!inWindow(p, now)) continue;
      if (p.abPreis && typeof price === 'number' && !isNaN(price) && price < p.abPreis) continue;
      if (p.laender && p.laender.length && p.laender.indexOf(geoCountry()) < 0) continue;
      if (!best || (p.prio || 0) > (best.prio || 0)) best = p;
    }
    return best;
  }
  function byId(id) { var l = list(); for (var i = 0; i < l.length; i++) if (l[i].id === id) return l[i]; return null; }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function format(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
  }
  function iconClass(name) {
    var map = { 'Lkw': 'lkw', 'Geschenk': 'geschenk', 'Blitz': 'blitz', 'Herz': 'herz' };
    return map[name] || '';
  }

  /* Kasten: Icon | Titel + Unterzeile | Trennlinie | Uhr (Std. Min. Sek.) – Farben aus dem Eintrag */
  function render(promo) {
    var box = document.createElement('span'); box.className = 'oc-ship-promo';
    var bg = /^#[0-9a-f]{3,8}$/i.test(promo.bg || '') ? promo.bg : BG;
    var fg = /^#[0-9a-f]{3,8}$/i.test(promo.fg || '') ? promo.fg : FG;
    box.style.backgroundColor = bg; box.style.color = fg; box.style.webkitTextFillColor = fg;
    if (promo.iconUrl) {
      /* Eigenes Icon (Upload im Eintrag) überschreibt die Icon-Auswahl – wird so gezeigt wie hochgeladen */
      var img = document.createElement('img'); img.className = 'oc-ship-promo_icon oc-ship-promo_icon--custom';
      img.src = promo.iconUrl; img.alt = ''; box.appendChild(img);
    } else {
      var icn = iconClass(promo.icon);
      if (icn) { var ic = document.createElement('span'); ic.className = 'oc-ship-promo_icon oc-ship-promo_icon--' + icn; box.appendChild(ic); }
    }
    var txt = document.createElement('span'); txt.className = 'oc-ship-promo_text';
    var t1 = document.createElement('span'); t1.className = 'oc-ship-promo_title'; t1.textContent = promo.titel || '';
    txt.appendChild(t1);
    if (promo.unterzeile) { var t2 = document.createElement('span'); t2.className = 'oc-ship-promo_sub'; t2.textContent = promo.unterzeile; txt.appendChild(t2); }
    box.appendChild(txt);
    if (promo.countdown) {
      var clock = document.createElement('span'); clock.className = 'oc-ship-promo_clock';
      var tm = document.createElement('span'); tm.className = 'oc-ship-timer'; tm.setAttribute('data-oc-promo-id', promo.id);
      tm.textContent = format(promo.ende * 1000 - Date.now());
      var units = document.createElement('span'); units.className = 'oc-ship-promo_units';
      ['Std.', 'Min.', 'Sek.'].forEach(function (u) { var e = document.createElement('span'); e.textContent = u; units.appendChild(e); });
      clock.appendChild(tm); clock.appendChild(units);
      box.appendChild(clock);
    }
    return box;
  }

  /* Änderungen (Start/Ende einer Aktion, Land bekannt) an Produktseite + Warenkorb melden */
  var listeners = [];
  function onChange(fn) { listeners.push(fn); }
  function notify() { for (var i = 0; i < listeners.length; i++) { try { listeners[i](); } catch (e) {} } }

  var lastKey = null;
  function tick() {
    var now = Date.now() / 1000, l = list(), key = '';
    for (var i = 0; i < l.length; i++) if (inWindow(l[i], now)) key += l[i].id + ',';
    if (key !== lastKey) { lastKey = key; notify(); }
    var timers = document.querySelectorAll('.oc-ship-timer');
    for (var j = 0; j < timers.length; j++) {
      var p = byId(timers[j].getAttribute('data-oc-promo-id'));
      if (p) timers[j].textContent = format(p.ende * 1000 - Date.now());
    }
  }

  /* Warenkorb-Drawer: während einer Aktion ersetzt der Kasten die Versandkosten-Leiste
     („Noch … bis zum kostenlosen Versand" bzw. „Kostenloser Versand freigeschaltet").
     „Nur ab Produktpreis" und „Nur in Kollektionen" gelten nur auf der Produktseite. */
  function mountCart() {
    var comps = document.querySelectorAll('.mini-cart_progress-component');
    var p = active(NaN);
    for (var i = 0; i < comps.length; i++) {
      var comp = comps[i];
      var existing = comp.querySelector(':scope > .oc-cart-promo');
      if (p) {
        if (existing && existing.getAttribute('data-oc-promo') === p.id) continue;
        if (existing) existing.remove();
        var box = render(p);
        box.classList.add('oc-cart-promo');
        box.setAttribute('data-oc-promo', p.id);
        comp.insertBefore(box, comp.firstChild);
        comp.classList.add('oc-cart-promo-active');
      } else {
        if (existing) existing.remove();
        comp.classList.remove('oc-cart-promo-active');
      }
    }
  }
  var raf = null;
  function scheduleCart() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; mountCart(); }); }

  window.ocPromo = { active: active, render: render, format: format, geoCountry: geoCountry, onChange: onChange, toNumber: toNumber };

  function init() {
    loadGeo(); /* immer – die Produktseite braucht das Land auch ohne Aktion („(DE)"-Zusatz) */
    if (!list().length) return;
    onChange(scheduleCart);
    mountCart();
    setInterval(tick, 1000);
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (m) {
        for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { scheduleCart(); return; }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
